import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import style from "./Manual_inventory.module.css";
import { API_BASE_URL, Inventory_api } from "../../../Apiconfig";
import { ReactTransliterate } from "react-transliterate";

const Inventorymanual = () => {
  const [products, setProducts] = useState([]);
  const [formInput, setFormInput] = useState({
    product_name: "",
    product_name2: "",
    product_name3: "",
    hindi_name: "",
    hindi_name2: "",
    hindi_name3: "",
    local_name: "",
    local_name2: "",
    local_name3: "",
    product_mrp: "",
    product_quantity: "",
    product_weight: "",
    buy_price: "",
    sale_price: "",
    product_discount: "",
    product_sku: "",
    product_code: "",
    product_expiry_date: "",
    product_category: "",
    product_type1: "",
    product_type2: "",
    product_type3: "",
    product_type4: "",
    product_rack_no: "",
    warehouse_location: "",
    transport_charge: "",
    batch_no: "",

    product_image: File, // Add a field for the image
  });

  const fileInputRef = useRef(null); // Add this ref

  const [batchNumber, setBatchNumber] = useState("");
  const [transportCharge, setTransportCharge] = useState(0);
  const [defaultWarehouse, setDefaultWarehouse] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // For file inputs, handle separately
    if (e.target.type === "file") {
      const file = e.target.files[0]; // Get the selected file
      setFormInput((prev) => ({
        ...prev,
        [name]: file, // Store the File object
      }));
    } else {
      setFormInput((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Add or update product
  const addProduct = () => {
    const {
      product_name,
      product_name2,
      product_name3,
      hindi_name,
      hindi_name2,
      hindi_name3,
      local_name,
      local_name2,
      local_name3,
      product_mrp,
      product_quantity,
      buy_price,
      sale_price,
      product_weight,
      product_discount,
      product_sku,
      product_code,
      product_expiry_date,
      product_category,
      product_type1,
      product_type2,
      product_type3,
      product_type4,
      product_rack_no,
      warehouse_location,
    } = formInput;

    // Validation
    if (
      !product_name ||
      !product_mrp ||
      !product_quantity ||
      !buy_price ||
      !sale_price ||
      !product_code
    ) {
      alert("Please fill all required fields.");
      return;
    }

    if (editIndex !== null) {
      // Update existing product
      const updatedProducts = [...products];
      updatedProducts[editIndex] = {
        ...formInput,
        warehouse_location: formInput.warehouse_location || defaultWarehouse,
      };
      setProducts(updatedProducts);
      setEditIndex(null);

    } else {
      // Add new product
      setProducts((prevProducts) => [
        ...prevProducts,
        {
          ...formInput,
          warehouse_location: formInput.warehouse_location || defaultWarehouse,
        },
      ]);
    }

    // Reset form
    setFormInput({
      product_name: "",
      product_name2: "",
      product_name3: "",
      hindi_name: "",
      hindi_name2: "",
      hindi_name3: "",
      local_name: "",
      local_name2: "",
      local_name3: "",
      product_mrp: "",
      product_quantity: "",
      product_weight: "",
      buy_price: "",
      sale_price: "",
      product_discount: "",
      product_sku: "",
      product_code: "",
      product_expiry_date: "",
      product_category: "",
      product_type1: "",
      product_type2: "",
      product_type3: "",
      product_type4: "",
      product_rack_no: "",
      warehouse_location: "",
    });

    // Clear the file input field
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }

  };

  // Distribute transport charge and assign batch number
  const distributeTransportCharge = () => {
    if (!batchNumber) {
      alert("Please enter a batch number.");
      return;
    }

    if (products.length === 0) {
      alert("No products to distribute transport charge.");
      return;
    }

    const totalQuantity = products.reduce(
      (total, product) => total + Number(product.product_quantity),
      0
    );

    const perUnitCharge = Number(transportCharge) / totalQuantity;

    const updatedProducts = products.map((product) => ({
      ...product,
      batch_no: batchNumber,
      transport_charge: Number(product.product_quantity) * perUnitCharge,
    }));
    console.log(perUnitCharge);
    setProducts(updatedProducts);
    alert("Transport charge distributed and batch number assigned.");
    setTransportCharge("");
    setDefaultWarehouse("");
    setBatchNumber("");
  };

  // Edit product details
  const editProduct = (index) => {
    setFormInput(products[index]);
    setEditIndex(index);
  };

  // Delete product
  const deleteProduct = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
  };

  // Save all products to the backend
  const saveProducts = async () => {
    try {
      const formData = new FormData();

      products.forEach((product, index) => {
        Object.entries(product).forEach(([key, value]) => {
          if (key === "product_image" && value instanceof File) {
            formData.append(`products[${index}][${key}]`, value);
          } else {
            formData.append(`products[${index}][${key}]`, value);
          }
        });
      });

      // Send the FormData to the API
      const response = await axios.post(
        `${Inventory_api}Add_inventory.php`,
        formData, // Pass FormData as the body
        {
          headers: {
            "Content-Type": "multipart/form-data", // Required for file uploads
          },
          withCredentials: true, // Include credentials if necessary
        }
      );

      // Handle response
      console.log(response);
      console.log(response.data);
      if (response.data.status === "success") {
        alert("Products saved successfully!");
        setProducts([]);
      } else {
        alert("Failed to save products.");
      }
    } catch (error) {
      console.error("Error saving products:", error);
      alert("Error saving products.");
    }
  };

  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  const [isRowOpen, setRowOpen] = useState(false);
  const openRow = () => setRowOpen(true);
  const closeRow = () => setRowOpen(false);

  const handleSubmit = () => {
    // Process form data
    console.log({
      batchNumber,
      transportCharge,
      defaultWarehouse,
    });
    // Close the form
    closeForm();
  };

  const toggleRow = () => {
    if (isRowOpen) {
      closeRow();
    } else {
      openRow();
    }
  };

  const [isRowOpencatt2, setRowOpencatt2] = useState(false);
  const openRowcatt2 = () => setRowOpencatt2(true);
  const closeRowcatt2 = () => setRowOpencatt2(false);

  const toggleRowcatt2 = () => {
    if (isRowOpencatt2) {
      closeRowcatt2();
    } else {
      openRowcatt2();
    }
  };

  const [isRowOpencatt3, setRowOpencatt3] = useState(false);
  const openRowcatt3 = () => setRowOpencatt3(true);
  const closeRowcatt3 = () => setRowOpencatt3(false);

  const toggleRowcatt3 = () => {
    if (isRowOpencatt3) {
      closeRowcatt3();
    } else {
      openRowcatt3();
    }
  };

  const [isRowOpencatt4, setRowOpencatt4] = useState(false);
  const openRowcatt4 = () => setRowOpencatt4(true);
  const closeRowcatt4 = () => setRowOpencatt4(false);

  const toggleRowcatt4 = () => {
    if (isRowOpencatt4) {
      closeRowcatt4();
    } else {
      openRowcatt4();
    }
  };

  const [isRowOpenpn2, setRowOpenpn2] = useState(false);
  const openRowpn2 = () => setRowOpenpn2(true);
  const closeRowpn2 = () => setRowOpenpn2(false);

  const toggleRowpn2 = () => {
    if (isRowOpenpn2) {
      closeRowpn2();
    } else {
      openRowpn2();
    }
  };

  const [isRowOpenpn3, setRowOpenpn3] = useState(false);
  const openRowpn3 = () => setRowOpenpn3(true);
  const closeRowpn3 = () => setRowOpenpn3(false);

  const toggleRowpn3 = () => {
    if (isRowOpenpn3) {
      closeRowpn3();
    } else {
      openRowpn3();
    }
  };

  const [isRowOpenhn2, setRowOpenhn2] = useState(false);
  const openRowhn2 = () => setRowOpenhn2(true);
  const closeRowhn2 = () => setRowOpenhn2(false);

  const toggleRowhn2 = () => {
    if (isRowOpenhn2) {
      closeRowhn2();
    } else {
      openRowhn2();
    }
  };

  const [isRowOpenhn3, setRowOpenhn3] = useState(false);
  const openRowhn3 = () => setRowOpenhn3(true);
  const closeRowhn3 = () => setRowOpenhn3(false);

  const toggleRowhn3 = () => {
    if (isRowOpenhn3) {
      closeRowhn3();
    } else {
      openRowhn3();
    }
  };


  const [isRowOpenln2, setRowOpenln2] = useState(false);
  const openRowln2 = () => setRowOpenln2(true);
  const closeRowln2 = () => setRowOpenln2(false);

  const toggleRowln2 = () => {
    if (isRowOpenln2) {
      closeRowln2();
    } else {
      openRowln2();
    }
  };

  const [isRowOpenln3, setRowOpenln3] = useState(false);
  const openRowln3 = () => setRowOpenln3(true);
  const closeRowln3 = () => setRowOpenln3(false);

  const toggleRowln3 = () => {
    if (isRowOpenln3) {
      closeRowln3();
    } else {
      openRowln3();
    }
  };

  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  // Debounce function to limit the number of API calls
  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  // Handle search query
  const handleSearch = debounce(async (searchQuery) => {
    if (!searchQuery || searchQuery.length < 3) { // Check if input is less than 3 characters
      setSearchResults([]);
      return;
    }
    try {
      const response = await axios.get(
        `${Inventory_api}SearchProducts.php?search=${searchQuery}`,
        {
          withCredentials: true,
        }
      );
      console.log(response.data); // Log the response to check the structure
      setSearchResults(response.data.products || []);
    } catch (error) {
      console.error("Error searching products:", error);
    }
  }, 1000);

  // Handle selecting a product
  const handleSelectProduct = (product) => {
    setSelectedProduct(product);
    setSearchResults([]); // Clear suggestions after selection

    // Set the selected product's MRP in the formInput state
    setFormInput((prev) => ({
      ...prev,
      product_name: product.product_name,
      product_name2: product.product_name2,
      product_name3: product.product_name3,
      hindi_name: product.hindi_name,
      hindi_name2: product.hindi_name2,
      hindi_name3: product.hindi_name3,
      local_name: product.local_name,
      local_name2: product.local_name2,
      local_name3: product.local_name3,
      product_mrp: product.product_mrp, // Set product_mrp to the selected product's MRP
      product_sku: product.product_sku,
      product_code: product.product_code,
      product_category: product.product_category,
      product_type1: product.product_type1,
      product_type2: product.product_type2,
      product_type3: product.product_type3,
      product_type4: product.product_type4,
      product_rack_no: product.product_rack_no,
      warehouse_location: product.warehouse_location,

    }));
  };

  return (
    <div className="container">

      {/* Input Form */}
      <div className="mb-4">

        <div className={`${style.manualinputcolrow} row mb-2 col-responsive`}>

          <h4 className={style.manultableheadingaddedit}>{editIndex !== null ? "Edit Product" : "Add New Product"}</h4>
          <hr className="mt-0 mb-2" />

          {/* Product Name */}
          <div className={`${style.manualinputcol} col-md-6`}>
            <div className="row">
              <div className="col">
                <div class="input-group mb-2">
                  <input
                    type="text"
                    className={`${style.inputfield} form-control`}
                    placeholder="Product Name"
                    name="product_name"
                    value={formInput.product_name}
                    onChange={(e) => {
                      handleInputChange(e);
                      handleSearch(e.target.value);
                    }}
                    required
                  />
                  <span
                    style={{
                      backgroundColor: isRowOpenpn2 ? "#236586" : "#4fa4cd",
                    }}
                    onClick={toggleRowpn2}
                    class="input-group-text px-1 text-light"
                    id="basic-addon1">{isRowOpenpn2 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                  </span>
                </div>

                {/* Display search results */}
                {searchResults.length > 0 && (
                  <ul>
                    {searchResults.map((product, index) => (
                      <li key={index} onClick={() => handleSelectProduct(product)}>
                        {product.product_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {isRowOpenpn2 && (
                <div className={`${style.manualinputcol} col`}>
                  <div class="input-group mb-2">

                    <input
                      type="text"
                      className={`${style.inputfield} form-control`}
                      placeholder="P Name 2"
                      name="product_name2"
                      value={formInput.product_name2}
                      onChange={handleInputChange}
                    />
                    <span
                      style={{
                        backgroundColor: isRowOpenpn3 ? "#236586" : "#4fa4cd",
                      }}
                      onClick={toggleRowpn3}
                      class="input-group-text px-1 text-light"
                      id="basic-addon1">{isRowOpenpn3 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                    </span>
                  </div>
                </div>
              )}

              {isRowOpenpn2 && isRowOpenpn3 && (
                <div className={`${style.manualinputcol} col`}>
                  <input
                    type="text"
                    className={`${style.inputfield} form-control`}
                    placeholder="P Name 3"
                    name="product_name3"
                    value={formInput.product_name3}
                    onChange={handleInputChange}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Hindi Name */}
          <div className={`${style.manualinputcol} col-md-6`}>
            <div className="row">
              <div className="col">
                <div class="input-group mb-2">
                  <div className="form-control p-0">
                    <ReactTransliterate
                      value={formInput.hindi_name}
                      onChangeText={(text) => {
                        setFormInput((prev) => ({
                          ...prev,
                          hindi_name: text, // Directly update the 'hindi_name' field in the formInput state
                        }));
                      }}
                      lang="hi"
                      className={`${style.transInputfield} form-control`}
                      placeholder="Hindi Name"
                    />
                  </div>

                  <span
                    style={{
                      backgroundColor: isRowOpenhn2 ? "#236586" : "#4fa4cd",
                    }}
                    onClick={toggleRowhn2}
                    class="input-group-text px-1 text-light"
                    id="basic-addon1">{isRowOpenhn2 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                  </span>
                </div>
              </div>

              {isRowOpenhn2 && (
                <div className={`${style.manualinputcol} col`}>
                  <div class="input-group mb-2">
                    <div className="form-control p-0">
                      <ReactTransliterate
                        value={formInput.hindi_name2}
                        onChangeText={(text) => {
                          setFormInput((prev) => ({
                            ...prev,
                            hindi_name2: text, // Directly update the 'hindi_name2' field in the formInput state
                          }));
                        }}
                        lang="hi"
                        className={`${style.transInputfield} form-control`}
                        placeholder="H Name 2"
                      />
                    </div>
                    <span
                      style={{
                        backgroundColor: isRowOpenhn3 ? "#236586" : "#4fa4cd",
                      }}
                      onClick={toggleRowhn3}
                      class="input-group-text px-1 text-light"
                      id="basic-addon1">{isRowOpenhn3 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                    </span>
                  </div>
                </div>
              )}

              {isRowOpenhn2 && isRowOpenhn3 && (
                <div className={`${style.manualinputcol} col`}>
                  <ReactTransliterate
                    value={formInput.hindi_name3}
                    onChangeText={(text) => {
                      setFormInput((prev) => ({
                        ...prev,
                        hindi_name3: text, // Directly update the 'hindi_name3' field in the formInput state
                      }));
                    }}
                    lang="hi"
                    className={`${style.inputfield} form-control`}
                    placeholder="H Name 3"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Local Name */}
          <div className={`${style.manualinputcol} col-md-6`}>
            <div className="row">
              <div className="col">
                <div class="input-group mb-2">
                  <input
                    type="text"
                    className={`${style.inputfield} form-control`}
                    placeholder="Local Name"
                    name="local_name"
                    value={formInput.local_name}
                    onChange={handleInputChange}
                  />
                  <span
                    style={{
                      backgroundColor: isRowOpenln2 ? "#236586" : "#4fa4cd",
                    }}
                    onClick={toggleRowln2}
                    class="input-group-text px-1 text-light"
                    id="basic-addon1">{isRowOpenln2 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                  </span>
                </div>

              </div>

              {isRowOpenln2 && (
                <div className={`${style.manualinputcol} col`}>
                  <div class="input-group mb-2">

                    <input
                      type="text"
                      className={`${style.inputfield} form-control`}
                      placeholder="L Name 2"
                      name="local_name2"
                      value={formInput.local_name2}
                      onChange={handleInputChange}
                    />
                    <span
                      style={{
                        backgroundColor: isRowOpenln3 ? "#236586" : "#4fa4cd",
                      }}
                      onClick={toggleRowln3}
                      class="input-group-text px-1 text-light"
                      id="basic-addon1">{isRowOpenln3 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                    </span>
                  </div>
                </div>
              )}

              {isRowOpenln2 && isRowOpenln3 && (
                <div className={`${style.manualinputcol} col`}>
                  <input
                    type="text"
                    className={`${style.inputfield} form-control`}
                    placeholder="L Name 3"
                    name="local_name3"
                    value={formInput.local_name3}
                    onChange={handleInputChange}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Price */}
          <div className={`${style.manualinputcol} col-md-6`}>
            <div className="row">
              <div className="col">
                <input
                  type="number"
                  className={`${style.inputfield} form-control mb-2`}
                  placeholder="MRP"
                  name="product_mrp"
                  value={formInput.product_mrp}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col">
                <input
                  type="number"
                  className={`${style.inputfield} form-control mb-2`}
                  placeholder="Buy Price"
                  name="buy_price"
                  value={formInput.buy_price}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col">
                <input
                  type="number"
                  className={`${style.inputfield} form-control mb-2`}
                  placeholder="Sale Price"
                  name="sale_price"
                  value={formInput.sale_price}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
          </div>

          {/* Quantity, Product Code */}
          <div className={`${style.manualinputcol} col-md-6`}>
            <div className="row">
              <div className="col">
                <input
                  type="number"
                  className={`${style.inputfield} form-control mb-2`}
                  placeholder="Quantity"
                  name="product_quantity"
                  value={formInput.product_quantity}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col">
                <input
                  type="text"
                  className={`${style.inputfield} form-control mb-2`}
                  placeholder="Product Code" // Added input for product code
                  name="product_code"
                  value={formInput.product_code}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
          </div>

          {/* Product Image */}
          <div className={`${style.manualinputcol} col-md-6`}>
            <div className="row">
              <div className="col">

                <input
                  type="file"
                  id="uploadImage"
                  className={`${style.inputfield} form-control mb-2`}
                  name="product_image"
                  accept="image/jpeg, image/png, image/gif"
                  ref={fileInputRef} // Attach the ref here
                  onChange={handleInputChange} // Attach the handler
                />
              </div>
            </div>
          </div>


          {/* More Fields */}
          <div className="accordion mb-2" id="moreFieldsAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#moreFields" aria-expanded="true" aria-controls="moreFields">
                  More Fields
                </button>
              </h2>
              <div id="moreFields" className="accordion-collapse collapse" data-bs-parent="#moreFieldsAccordion">
                <div className="accordion-body">

                  <div className={`${style.addcolmaincontainer} container-fluid`}>
                    <div className="row">

                      <div className="col-md-6">
                        <div className="row">
                          <div className={`${style.manualinputcol} col`}>
                            <input
                              type="text"
                              className={`${style.inputfield} form-control mb-2`}
                              placeholder="Weight"
                              name="product_weight"
                              value={formInput.product_weight}
                              onChange={handleInputChange}
                              required
                            />
                          </div>

                          <div className={`${style.manualinputcol} col`}>
                            <input
                              type="text"
                              className={`${style.inputfield} form-control mb-2`}
                              placeholder="DISCOUNT"
                              name="product_discount"
                              value={formInput.product_discount}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className={`${style.manualinputcol} col`}>
                          <div class="input-group mb-2">
                            <span class="input-group-text" id="basic-addon1" style={{ fontSize: 12 }}>Expiry</span>
                            <input
                              type="date"
                              className={`${style.inputfield} form-control`}
                              placeholder="Expiry Date"
                              name="product_expiry_date"
                              value={formInput.product_expiry_date}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="row">
                          <div className={`${style.manualinputcol} col`}>
                            <input
                              type="text"
                              className={`${style.inputfield} form-control mb-2`}
                              placeholder="SKU"
                              name="product_sku"
                              value={formInput.product_sku}
                              onChange={handleInputChange}
                            />
                          </div>

                          <div className={`${style.manualinputcol} col`}>
                            <input
                              type="text"
                              className={`${style.inputfield} form-control mb-2`}
                              placeholder="Category"
                              name="product_category"
                              value={formInput.product_category}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="row">
                          <div className={`${style.manualinputcol} col`}>
                            <input
                              type="text"
                              className={`${style.inputfield} form-control mb-2`}
                              placeholder="RACK NO."
                              name="product_rack_no"
                              value={formInput.product_rack_no}
                              onChange={handleInputChange}
                            />
                          </div>

                          <div className={`${style.manualinputcol} col`}>
                            <input
                              type="text"
                              className={`${style.inputfield} form-control mb-2`}
                              placeholder="Warehouse Location"
                              name="warehouse_location"
                              value={formInput.warehouse_location}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Types */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row">
                          <div className={`${style.manualinputcol} col`}>
                            <div class="input-group mb-2">
                              <input
                                type="text"
                                className={`${style.inputfield} ${style.type1col} form-control`}
                                placeholder="Type 1"
                                name="product_type1"
                                value={formInput.product_type1}
                                onChange={handleInputChange}
                              />
                              <span
                                style={{
                                  backgroundColor: isRowOpencatt2 ? "#236586" : "#4fa4cd",
                                }}
                                onClick={toggleRowcatt2}
                                class="input-group-text px-1 text-light"
                                id="basic-addon1">{isRowOpencatt2 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                              </span>
                            </div>
                          </div>

                          {isRowOpencatt2 && (
                            <div className={`${style.manualinputcol} col`}>
                              <div class="input-group mb-2">
                                <input
                                  type="text"
                                  className={`${style.inputfield} form-control`}
                                  placeholder="Type 2"
                                  name="product_type2"
                                  value={formInput.product_type2}
                                  onChange={handleInputChange}
                                />
                                <span
                                  style={{
                                    backgroundColor: isRowOpencatt3 ? "#236586" : "#4fa4cd",
                                  }}
                                  onClick={toggleRowcatt3}
                                  class="input-group-text px-1 text-light"
                                  id="basic-addon1">{isRowOpencatt3 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="row">
                          {isRowOpencatt2 && isRowOpencatt3 && (
                            <div className={`${style.manualinputcol} col`}>
                              <div class="input-group mb-2">
                                <input
                                  type="text"
                                  className={`${style.inputfield} form-control`}
                                  placeholder="Type 3"
                                  name="product_type3"
                                  value={formInput.product_type3}
                                  onChange={handleInputChange}
                                />
                                <span
                                  style={{
                                    backgroundColor: isRowOpencatt4 ? "#236586" : "#4fa4cd",
                                  }}
                                  onClick={toggleRowcatt4}
                                  class="input-group-text px-1 text-light"
                                  id="basic-addon1">{isRowOpencatt4 ? <i class='fa-solid fa-minus'></i> : <i class='fa-solid fa-plus'></i>}
                                </span>
                              </div>
                            </div>
                          )}

                          {isRowOpencatt2 && isRowOpencatt3 && isRowOpencatt4 && (
                            <div className={`${style.manualinputcol} col`}>
                              <input
                                type="text"
                                className={`${style.inputfield} form-control`}
                                placeholder="Type 4"
                                name="product_type4"
                                value={formInput.product_type4}
                                onChange={handleInputChange}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* Add Button */}
          <div className="col">
            <div className={`${style.addtolistbtnrow} row mb-2 mx-0`}>
              <button
                className={`${style.addProductBtn} btn btn-primary`}
                onClick={addProduct}
              >
                {editIndex !== null ? "Update Product" : "Add Product"}
              </button>
            </div>
          </div>

        </div>



        {/* Display Products */}
        <div className={`${style.addproducttable} mt-4`}>
          <h4 className={style.manultableheadingaddedit}>Products</h4>
          <hr className="mt-0 mb-2" />
          <div className="tableContainer table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className={style.inputfield}>Product Name</th>
                  <th className={style.inputfield}>Product Code</th>
                  <th className={style.inputfield}>SKU</th>
                  <th className={style.inputfield}>Category</th>
                  <th className={style.inputfield}>Quantity</th>
                  <th className={style.inputfield}>Buy Price</th>
                  <th className={style.inputfield}>Sale Price</th>
                  <th className={style.inputfield}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, index) => (
                  <tr key={index}>
                    <td>{product.product_name}</td>
                    <td>{product.product_code}</td> {/* Display product code */}
                    <td>{product.product_sku}</td>
                    <td>{product.product_category}</td>
                    <td>{product.product_quantity}</td>
                    <td>{product.buy_price}</td>
                    <td>{product.sale_price}</td>
                    <td>
                      <button
                        className={`${style.addmore} btn btn-warning btn-sm mr-2`}
                        onClick={() => editProduct(index)}
                      >
                        Edit
                      </button>
                      <button
                        className={`${style.addmore} btn btn-danger btn-sm`}
                        onClick={() => deleteProduct(index)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>



          {/* Batch and Transport Charge */}
          <div className={`${style.addtolistbtnrow} row mx-0 mb-2`}>
            {/* Main Button to Open Form */}
            <button
              className={`${style.addProductBtn} btn btn-primary`}
              onClick={openForm}
            >
              Distribute Transport Charge
            </button>

            {/* Conditional Rendering of the Form */}
            {isFormOpen && (
              <div className="modal-background">
                <div className="modal-content">
                  <h4>Distribute Transport Charge</h4>
                  <div className="mb-4">
                    <div className="row">
                      <div className={`${style.manualinputcol} col`}>
                        <input
                          type="text"
                          className={`${style.inputfield} form-control`}
                          placeholder="Batch Number"
                          value={batchNumber}
                          onChange={(e) => setBatchNumber(e.target.value)}
                        />
                      </div>
                      <div className={`${style.manualinputcol} col`}>
                        <input
                          type="number"
                          className={`${style.inputfield} form-control`}
                          placeholder="Transport Charge"
                          value={transportCharge}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            setTransportCharge(isNaN(value) ? "" : value);
                          }}
                        />
                      </div>
                      <div className={`${style.manualinputcol} col`}>
                        <input
                          type="text"
                          className={`${style.inputfield} form-control`}
                          placeholder="Default Warehouse Location"
                          value={defaultWarehouse}
                          onChange={(e) => setDefaultWarehouse(e.target.value)}
                        />
                      </div>
                    </div>
                    {/* Cancel and Submit Buttons */}
                    <div className="mt-3">
                      <button
                        className={`${style.addmore} btn btn-secondary me-2`}
                        onClick={closeForm}
                      >
                        Cancel
                      </button>
                      <button
                        className={`${style.addmore} btn btn-primary`}
                        onClick={distributeTransportCharge}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>


          <div className={style.saveproductbtnrow}>
            <button
              className={`${style.savebtn} btn`}
              onClick={saveProducts}
            >
              Save Products
            </button>
          </div>

        </div>
      </div>
      {
        successMessage && (
          <div className={style.successMessage}>{successMessage}</div>
        )
      }
    </div >
  );
};

export default Inventorymanual;
